import { useTranslator } from "@brickme/frontend-common/src/i18n/translation.tsx";
import Modal from "~/components/modal.tsx";

type GiftingOptionsInfoModalProps = {
	readonly show: boolean;
	readonly onClose: () => void;
};

export default function GiftingOptionsInfoModal({
	show,
	onClose,
}: GiftingOptionsInfoModalProps) {
	const t = useTranslator();
	return (
		<Modal
			show={show}
			onClose={onClose}
			slimBorder
			size="dynamic"
			bodyClassName="gifting-options-info-modal"
		>
			<Modal.Text textAlign="left">
				<p>
					{t(
						"Brick Me mosaic kits make fantastic gifts. At Brick Me, you can absolutely upload a photo, design a mosaic, and order a kit as a gift - the classic way. But sometimes you don't know which photo to use, or you want your recipient to choose their own. Exactly for this purpose, we offer two gifting options.",
					)}
				</p>
				<h3>
					<strong>{t("Brick Mosaic (gift the product)")}</strong>
				</h3>
				<p>
					{t(
						"You pick the mosaic size and pay now. Your recipient gets a link to upload their photo, design their mosaic and confirm delivery. You can choose add-ons for your recipient like a frame or gift-wrapping, add a personal note, and schedule the link delivery for up to 2 weeks in the future. No payment needed on their side when they order, unless they choose to upgrade to a larger size. Because you're buying the product, you lock in any promos or sales at checkout. It also feels a bit more personal: you've chosen the actual gift, and they simply make it theirs.",
					)}
				</p>
				<h3>
					<strong>{t("Gift Card (gift store credit)")}</strong>
				</h3>
				<p>
					{t(
						"You choose a digital card amount and they can spend it on anything in our store. The gift card will be sent to you via email, and you can forward it to your recipient, or print it and give it to them. Gift cards themselves aren't discounted during sales, but they can be used to buy items that are on sale later - so the savings help the recipient, not the purchaser. One thing to consider: it can be tricky to guess the right amount. A card might not fully cover what they want, or it might leave a small balance.",
					)}
				</p>
				<h3>
					<strong>{t("Which should I choose?")}</strong>
				</h3>
				<ul>
					<li>
						{t(
							'Pick a Brick Mosaic if you want a more "I picked this for you" moment, and to take advantage of sales or promotions (if any are available). You pick the size now – they design later – we ship to them.',
						)}
					</li>
					<li>
						{t(
							'Pick a Gift Card if you want maximum flexibility for your recipient to decide what and when to buy. The classic way to say, "here\'s your budget – you decide".',
						)}
					</li>
				</ul>
			</Modal.Text>
			<Modal.Actions
				actions={[
					{
						text: t("Close"),
						onClick: onClose,
						type: "ghost",
					},
				]}
			/>
		</Modal>
	);
}
